import { render } from "./PublicationCard.vue.js?vue&type=template&id=31eed6fe&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCard.vue?vue&type=template&id=31eed6fe&scoped=true"
import script from "./PublicationCard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCard.vue?vue&type=script&lang=js"

import "./PublicationCard.vue.scss?vue&type=style&index=0&id=31eed6fe&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCard.vue?vue&type=style&index=0&id=31eed6fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31eed6fe"],['__file',"src/Web/scripts/components/PublicationCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31eed6fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31eed6fe', __exports__)) {
    api.reload('31eed6fe', __exports__)
  }
  
  module.hot.accept("./PublicationCard.vue.js?vue&type=template&id=31eed6fe&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCard.vue?vue&type=template&id=31eed6fe&scoped=true", () => {
    api.rerender('31eed6fe', render)
  })

}


export default __exports__